import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

/**
 * Decode HTML entities back to their original characters.
 * Used to display HTML-escaped content (e.g., "&lt;此日期前最佳：2026.12&gt;" → "<此日期前最佳：2026.12>")
 * in plain text contexts where dangerouslySetInnerHTML is not used.
 */
export function decodeHtmlEntities(text: string): string {
  if (!text || typeof text !== 'string') return text;
  
  const textarea = document.createElement('textarea');
  textarea.innerHTML = text;
  return textarea.value;
}
